
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/werkliste",
      function () {
        return require("private-next-pages/werkliste/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/werkliste"])
      });
    }
  